// extracted by mini-css-extract-plugin
module.exports = {"spin":"SpinnerOverlay_spin__dAPPj"};